<template>
  <div ref="appContent" class="app-body">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="100px">
      <el-row :gutter="16" v-if="type === 'outlet'" id="formBox1">
        <el-col :span="5">
          <el-form-item label="出口发票号：" prop="receiptCode" label-width="120px">
            <common-drop v-model="dataForm.receiptCode" ref="codeDrop" url="/trade/code/list" label-name="virtualCode"
              val-name="virtualCode" @loaded="codeDropLoaded" size="mini" v-if="!$c.str2bool(id)"
              :filterable="true"></common-drop>
            <el-input v-else size="mini" :disabled="true" v-model="dataForm.receiptCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="装船日期：" prop="shipDate">
            <el-date-picker v-model="dataForm.shipDate" type="date" value-format="yyyy-MM-dd" style="width: 100%"
              placeholder="选择出装船日期" size="mini">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="目的港：" prop="destination">
            <dict-dropdown v-model="dataForm.destination" size="mini" dictName="harbour"
              :filterable="true"></dict-dropdown>
            <!--            <el-input v-model="dataForm.destination" placeholder="请输入目的港" size="mini"></el-input>-->
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="船名：" prop="vesselName" label-width="80px">
            <el-input v-model="dataForm.vesselName" placeholder="船名" size="mini"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="出发港：" prop="fromHarbour" label-width="80px">
            <el-input v-model="dataForm.fromHarbour" placeholder="出发港" size="mini"></el-input>
          </el-form-item>
        </el-col>

      </el-row>
      <template v-if="type === 'sell'">
        <el-row :gutter="16" id="formBox2">
          <el-col :span="6">
            <el-form-item label="客户：" prop="customerId" label-width="80px">
              <el-select v-model="dataForm.customerId" size="mini" style="width: 100%" :filterable="true"
                @change="customerChanged">
                <el-option v-for="item in customerList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="税号：" prop="taxCode" label-width="80px">
              <el-input v-model="dataForm.taxCode" placeholder="请输入税号" size="mini">></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="银行：" prop="bank" label-width="80px">
              <el-input v-model="dataForm.bank" placeholder="请输入银行" size="mini">></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="银行账号：" prop="accountCode">
              <el-input v-model="dataForm.accountCode" placeholder="请输入银行账号" size="mini">></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <el-form-item label="发货日期：" prop="shipDate">
              <el-date-picker v-model="dataForm.shipDate" type="date" value-format="yyyy-MM-dd" style="width: 100%"
                placeholder="选择发货日期" size="mini">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </template>

      <div class="table-bar" id="tableBar" style="justify-content: flex-start">
        <div>
          <el-button size="mini" icon="el-icon-plus" @click="$refs.makeDetailDialog.init()" type="primary">选择品番
          </el-button>
          <el-button size="mini" icon="el-icon-upload" @click="showCommonDialog()" type="warning">导入明细
          </el-button>
        </div>
        <div style="position: relative;margin-left: 10px;" v-if="type === 'outlet'">
          <tool-tip v-if="codeDropToolTip">暂无可用进出口发票,请至"系统设置-进出口发票"进行领取</tool-tip>
        </div>
      </div>
      <el-table :data="dataForm.detailList" border empty-text="请选择或导入发货品番" style="width: 100%"
        :max-height="tableHeight">
        <el-table-column type="index" width="50" label="行号" header-align="center" align="center"></el-table-column>
        <!--        <el-table-column label="agreementid" prop="agreementId" align="center" min-width="160">-->
        <!--        </el-table-column>-->
        <!--        <el-table-column label="productid" prop="productId" align="center" min-width="160">-->
        <!--        </el-table-column>-->
        <el-table-column label="外销合同号" prop="agreementCode" align="center" min-width="160">
        </el-table-column>
        <el-table-column label="出货工厂" align="center" min-width="200" prop="factoryName">
        </el-table-column>
        <el-table-column label="品番号" prop="code" align="center" min-width="160">
        </el-table-column>
        <el-table-column label="SKU" prop="skuCode" align="center" min-width="160">
        </el-table-column>
        <el-table-column label="品名" align="center" min-width="160" prop="name">
        </el-table-column>
        <el-table-column label="颜色" align="center" min-width="140" prop="color">
        </el-table-column>
        <el-table-column label="规格" align="center" min-width="140" prop="size">
        </el-table-column>
        <el-table-column label="发货数量" align="center" width="120">
          <template slot-scope="scope">
            <el-form-item :prop="'detailList.' + scope.$index + '.totalCount'" :rules="detailRule.totalCount"
              label-width="0" style="margin-top: 20px">
              <el-input size="mini" v-model="scope.row.totalCount" placeholder="出货数量"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="发货单价" align="center" width="120">
          <template slot-scope="scope">
            <el-form-item :prop="'detailList.' + scope.$index + '.price'" :rules="detailRule.price" label-width="0"
              style="margin-top: 20px">
              <el-input size="mini" v-model="scope.row.price" placeholder="出货单价"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="每箱入数" align="center" width="120" v-if="type === 'outlet'">
          <template slot-scope="scope">
            <el-form-item :prop="'detailList.' + scope.$index + '.preBoxCount'" :rules="detailRule.preBoxCount"
              label-width="0" style="margin-top: 20px">
              <el-input size="mini" v-model="scope.row.preBoxCount" placeholder="每箱入数"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="箱数" header-align="center" align="center" width="120" v-if="type === 'outlet'">
          <template slot-scope="scope">
            <el-form-item :prop="'detailList.' + scope.$index + '.boxCount'" :rules="detailRule.boxCount"
              label-width="0" style="margin-top: 20px">
              <el-input size="mini" v-model="scope.row.boxCount"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="纸箱尺寸" header-align="center" v-if="type === 'outlet'">
          <el-table-column label="长(cm)" header-align="center" align="center" width="120">
            <template slot-scope="scope">
              <el-form-item :prop="'detailList.' + scope.$index + '.boxLong'" :rules="detailRule.boxLong"
                label-width="0" style="margin-top: 20px">
                <el-input size="mini" v-model="scope.row.boxLong"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="宽(cm)" header-align="center" align="center" width="120">
            <template slot-scope="scope">
              <el-form-item :prop="'detailList.' + scope.$index + '.boxWidth'" :rules="detailRule.boxWidth"
                label-width="0" style="margin-top: 20px">
                <el-input size="mini" v-model="scope.row.boxWidth"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="高(cm)" header-align="center" align="center" width="120">
            <template slot-scope="scope">
              <el-form-item :prop="'detailList.' + scope.$index + '.boxHeight'" :rules="detailRule.boxHeight"
                label-width="0" style="margin-top: 20px">
                <el-input size="mini" v-model="scope.row.boxHeight"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="毛重(kg)" header-align="center" align="center" width="100" v-if="type === 'outlet'">
          <template slot-scope="scope">
            <el-form-item :prop="'detailList.' + scope.$index + '.weight'" :rules="detailRule.weight" label-width="0"
              style="margin-top: 20px">
              <el-input size="mini" v-model="scope.row.weight"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" width="100" label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button icon="el-icon-remove" type="text" @click="delRow(scope.$index, scope.row, 'detailList')">
              移除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div class="footer">
      <el-button @click="cancel">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{$t('confirm')}}
      </el-button>
    </div>
    <common-upload ref="commonUpload" @success="uploadSuccessHandler" uploadUrl="/trade/boxform/import"
      :templateUrl="type === 'sell' ? '/static/template/销售开票导入模板.xlsx' : '/static/template/箱单导入模板.xlsx'"
      title="箱单明细导入"></common-upload>
    <make-detail-dialog ref="makeDetailDialog" :customer-id="dataForm.customerId" title="选择发货明细"
      @change="makeDetailChange"></make-detail-dialog>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import MakeDetailDialog from '@/components/MakeDetailDialog'
import CommonDrop from '@/components/CommonDrop'
import { moneyValidator } from '@/utils/validate'
import DictDropdown from '@/components/DictDropdown/index.vue'
import BigNumber from 'bignumber.js'

export default {
  components: { DictDropdown, MakeDetailDialog, CommonDrop },
  data() {
    return {
      id: '',
      dataForm: {},
      tableHeight: 500,
      codeDropToolTip: false,
      type: 'outlet',
      customerList: [],
      saving: false,
      boxCodeInfo:{}//当前已选择的箱单号信息
    }
  },
  computed: {
    detailRule() {
      const numValidate = function (rule, value, callback) {
        if (!value) {
          callback()
        }
        let reg = /\d+/g
        if (!reg.test(value)) {
          callback(new Error('请输入正确的数字'))
        }
        callback()
      }
      return {
        boxCount: [{ validator: numValidate, trigger: 'change' }],
        preBoxCount: [{ validator: numValidate, trigger: 'change' }],
        boxLong: [{ validator: numValidate, trigger: 'change' }],
        boxWidth: [{ validator: numValidate, trigger: 'change' }],
        boxHeight: [{ validator: numValidate, trigger: 'change' }],
        weight: [{ validator: numValidate, trigger: 'change' }],
        totalCount: [
          { required: true, message: '请填写数量', trigger: 'change' },
          { validator: numValidate, trigger: 'change' },
        ],
        price: [
          { required: true, message: '请填写单价', trigger: 'change' },
          { validator: moneyValidator, trigger: 'change' },
        ],
      }
    },
    dataRule() {
      return {
        customerId: [
          { required: true, message: '请选择客户', trigger: 'change' }],
        taxCode: [
          { required: true, message: '请填写税号', trigger: 'change' }],
        destination: [
          { required: true, message: '请填写箱单目的地', trigger: 'change' }],
        receiptCode: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
        ],
        shipDate: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
        ],
      }
    },
  },
  activated() {
    this.type = this.$route.query.type || 'outlet'
    this.id = this.$route.query.id
    if (this.type === 'sell') {
      this.queryCustomerList()
    }
    this.init()
  },
  mounted() {
    this.$nextTick(() => {
      let tableBar = document.getElementById('tableBar')
      let tableBarHeight = tableBar ? tableBar.offsetHeight : 0
      let formBox = document.getElementById('formBox1')
      if (!formBox) {
        formBox = document.getElementById('formBox2')
      }
      let formBoxHeight = formBox ? formBox.offsetHeight : 0
      console.log(this.$refs.appContent.offsetHeight, tableBarHeight, formBoxHeight)
      this.tableHeight = this.$refs.appContent.offsetHeight - tableBarHeight - formBoxHeight - 120
    })
  },
  watch: {
    'dataForm.receiptCode': function (val,oldVal)  {
      if(!val||!this.$refs.codeDrop){
        this.dataForm.customerId=''
        return
      }
      this.dataForm.customerId=this.$refs.codeDrop.dataList.find(c=>c.virtualCode===val).customerId

    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$refs.makeDetailDialog) {
      this.$refs.makeDetailDialog.clearSelection()
    }
    next()
  },
  methods: {
    //客户下拉列表选择事件
    customerChanged(e) {
      let customer = this.customerList.find(item => item.id === e)
      if (!customer) {
        return
      }
      this.dataForm.taxCode = customer.receiptCode
      this.dataForm.bank = customer.bankName
      this.dataForm.accountCode = customer.bankCode
    },
    //当销售开票时,查询客户列表
    async queryCustomerList() {
      const { data: res } = await this.$http.get(`/trade/customer/list`)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.customerList = res.data
    },
    //查询价格
    async queryPrice() {
      if (this.dataForm.detailList.length === 0) {
        return
      }
      let agreementIds = this.dataForm.detailList.map(item => item.agreementId)
      let productIds = this.dataForm.detailList.map(item => item.productId)
      let loading = this.$loading({
        lock: true,
        text: '正在读取价格'
      })
      try {
        const { data: res } = await this.$http.post(`/trade/agreement/detail/price`, { agreementIds, productIds })
        if (res.code != 0) {
          loading.close()
          return this.$message.error(res.msg)
        }
        if (!res.data || res.data.length === 0) {
          loading.close()
          return
        }
        res.data.forEach(item => {
          let row = this.dataForm.detailList.find(m => m.agreementId == item.agreementId && m.productId == item.productId)
          if (!row) {
            return
          }
          row.price = item.amount
        })

      } catch (e) {
        console.log(e)
      }
      loading.close()
    },
    codeDropLoaded(data) {
      if (this.id) {
        return false
      }
      this.codeDropToolTip = data.length === 0
    },
    makeDetailChange(e) {
      if (!e || e.length === 0) {
        return
      }
      let tmp = this.dataForm.detailList || []
      let tableId=tmp.length
      e.forEach(item => {
        if (tmp.find(m => m.id === item.id)) {
          return
        }
        tableId+=1
        tmp.push({
          id:tableId,
          agreementId: item.orderId,
          agreementCode: item.orderCode,
          productId: item.productId,
          code: item.code,
          name: item.name,
          size: item.size,
          color: item.color,
          skuCode: item.skuCode,
          factoryName: item.factoryName,
          factoryId: item.factoryId,
          boxCount: '',
          preBoxCount: '',
          totalCount: '',
          totalSize: '',
          weight: '',
          preSize: '',
          boxLong: '',
          boxWidth: '',
          boxHeight: '',
          price: 0
        })
      })
      this.$set(this.dataForm, 'detailList', tmp)
      //销售开票时查询价格
      this.queryPrice()
    },
    //显示通用导入弹窗
    showCommonDialog() {
      this.$refs.commonUpload.init()
    },
    uploadSuccessHandler(e) {
      if (e && e.length > 0) {
        e = e.map(row => {
          return {
            ...row,
            factoryName: row.storageName
          }
        })
      }
      this.$set(this.dataForm, 'detailList', e)
      this.$nextTick(() => {
        this.queryPrice()
      })
    },

    delRow(index) {
      this.dataForm.detailList.splice(index, 1)
    },
    reset() {
      this.dataForm = {
        customerId:'',
        receiptCode: '',
        shipDate: '',
        destination: '',
        vesselName: '',
        fromHarbour: '',
        companyName: '',
        taxCode: '',
        bank: '',
        accountCode: '',
        detailList: [],
      }
    },
    async init() {
      this.reset()
      if (this.id) {
        this.getInfo()
      }
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.clearValidate()
        }
      })
    },
    // 获取信息
    getInfo() {
      this.$http
        .get(`/trade/boxform/${this.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data,
          }
        })
        .catch(() => {
        })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        this.$refs['dataForm'].validate((valid) => {
          if (!valid) {
            return false
          }
          let postForm = {
            ...this.dataForm,
            formType: this.type
          }
          postForm.detailList.forEach(item => {
            if(String(item.id).length<4){
              item.id=null
            }
            if(item.boxHeight&&item.boxWidth&&item.boxLong){
              item.preSize=new BigNumber(item.boxHeight).multipliedBy(item.boxWidth).multipliedBy(item.boxLong)
            item.totalSize=item.preSize.multipliedBy(item.boxCount).toFixed(2)
            item.preSize=item.preSize.toFixed(2)
            }
          })
          if (this.saving) {
            return
          }
          this.saving = true
          let url=this.id ? '/erp/box/update' : '/erp/box/save'
          this.$api2.post(url, postForm)
            .then((res) => {
              this.saving = false
              this.$message({
                message: this.$t('prompt.success'),
                type: 'success',
                duration: 500,
                onClose: () => {
                  this.cancel()
                },
              })
            })
            .catch(() => {
              this.saving = false
            })
        })
      },
      1000,
      { leading: true, trailing: false }
    ),
    cancel() {
      this.$router.back()
    },
  },
}
</script>
